<template>
  <div class="search-form pr-2">
    <el-row :gutter="5">
      <el-col :span="6">
        <dict-select
          v-model="form.pdProcessDictStep"
          url="/master/common/dict/biz"
          :body="{ dictType: 'pdProcessDictStep' }"
          :placeholder="$l('form_search_allTech') || '全部工艺'"
          filterable
          clearable
          size="small"
          @change="query"
        >
        </dict-select>
      </el-col>
      <el-col :span="18">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.techName"
            :placeholder="
              $l('table_search_placeholder_chooseTech') || '工艺名称 搜索……'
            "
          />
          <b-input-group-append>
            <b-button-group slot="reference">
              <b-button variant="primary" size="sm" @click="query">
                <i class="fa fa-search" />
              </b-button>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
const initForm = { pdProcessDictStep: '', techName: '' }
export default {
  data() {
    return {
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    reset() {
      this.form = { ...initForm }
    },
  },
}
</script>
